import { EmailOpenOutlineIcon } from './EmailOpenOutlineIcon';

/**
 * author: Austin Andrews
 * id 4F7B4311-FC6B-463D-A2A3-760554AF144E
 * name email-open-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-open-outline.svg
 * tags
 */
export const EnvelopeOpenOutlineIcon = EmailOpenOutlineIcon;
export default EnvelopeOpenOutlineIcon